import { Box, Typography } from "@mui/material";

const styles = {
    open: {
        backgroundColor: '#2859E0',
        textColor: '#FFFFFF',
    },
    'in progress': {
        backgroundColor: '#E8EEFF',
        textColor: '#2E2E2E',
    },
    'action completed': {
        backgroundColor: '#E8EEFF',
        textColor: '#2E2E2E',
    },
    'resolved': {
        backgroundColor: '#008A15',
        textColor: '#EEF4DB',
    },
    'force resolved': {
        backgroundColor: '#EEF4DB',
        textColor: '#196D00',
    },
    'auto resolved': {
        backgroundColor: '#EEF4DB',
        textColor: '#196D00',
    }
}

const StatusBadge = ({ status }) => {

    const statusKey = Object.keys(styles).includes(status?.toLowerCase()) ? status?.toLowerCase() : Object.keys(styles)[0];
    const textColor = styles[statusKey]['textColor'];
    const backgroundColor = styles[statusKey]['backgroundColor'];
    const label = status;

    return (
        <Box
            sx={{
                borderRadius: '14px',
                px: 1.5,
                py: 0.25,
                bgcolor: backgroundColor,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}
        >
            <Typography variant="fw400s12c000000" sx={{color: textColor, lineHeight: '20px'}}>
                {label}
            </Typography>
        </Box>
    )
}

export default StatusBadge;
